import { FieldValues, Path, UseFormRegister } from "react-hook-form";
import styled from "styled-components";
import { InputWrapper } from "../../../pages/onboarding/AboutYouConnectWith.page";
import { Row } from "../../../styles/Utils";

interface BirthDateInputProps<T extends FieldValues> {
  register: UseFormRegister<T>; // Register function from RHF
  name: Path<T>; // The field name should be a key from the form data type
  disabled?: boolean;
}

export function BirthDateInput<T extends FieldValues>({ register, name }: BirthDateInputProps<T>) {
  const today = new Date();
  const minDate = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate()).toISOString().split("T")[0]; // 100 years ago
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate()).toISOString().split("T")[0]; // 18 years ago
  // For Safari which does not display a placeholder for date type input
  const defaultValue = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate())
    .toISOString()
    .split("T")[0];

  // TODO : Use useFormContext more in other comps
  // const { watch } = useFormContext<IFormInput>();
  // const isBirthDateNull = !watch("birthDate");

  return (
    <InputWrapper>
      <Row $justifyContent="space-between">
        <span>Your BirthDay: </span>
        <DateInput
          {...register(name, {
            required: true,
            validate: {
              dateRange: (value) => {
                const dateValue = value as string;
                if (dateValue < minDate) {
                  return `Birth Date must be after ${minDate}`;
                } else if (dateValue > maxDate) {
                  return `Birth Date must be before ${maxDate}`;
                }
                return true; // Return true if the validation is successful
              },
            },
          })}
          type="date"
          min={minDate}
          max={maxDate}
          defaultValue={defaultValue}
        />
      </Row>
    </InputWrapper>
  );
}

const DateInput = styled.input`
  background: inherit;
  color: inherit;
  border: none;
  outline: none;
  cursor: pointer;
  text-transform: uppercase;
  text-align: end;
  font-size: inherit;
  width: fit-content; // For Android Mobile
`;
